/**
 * OVERRIDE ImageView.jsx
 */

import ImageView from '../../../../components/View/ImageView';

export default ImageView;